import { useContext } from 'react';

import { PrepareDisclosuresWizardContext } from '../PrepareDisclosuresWizardContext';

const usePrepareDisclosuresWizard = () => {
  const context = useContext(PrepareDisclosuresWizardContext);

  if (!context) {
    throw new Error(
      'usePrepareDisclosuresWizard must be used within a PrepareDisclosuresWizardProvider',
    );
  }

  return context;
};

export default usePrepareDisclosuresWizard;
